const timeLoaderSrc = `${process.env.PUBLIC_URL || ''}/assets/time.gif`;

export default function LoadingIndicator({ label = 'Loading...', variant = 'inline' }) {
  return (
    <span className={`time-loader time-loader-${variant}`} role="status" aria-live="polite">
      <img className="time-loader-img" src={timeLoaderSrc} alt="" aria-hidden="true" />
      {label ? <span>{label}</span> : null}
    </span>
  );
}
